import React, {useState} from 'react'
import {useMutation} from '@apollo/client'
import {Modal} from 'react-bootstrap'
import Swal from 'sweetalert2'
import {EditFormImoveProprietarios} from './EditForm'
import {KTSVG} from '../../../../_metronic/helpers'
import {MutationDeleteProprietarios} from '../../../graphql/services/Proprietarios'
import {MutationCreateDiligenciaHistorico} from '../../../graphql/services/DiligenciaHistorico'
import {PUT_PROPRIETARIO} from '../../../graphql/mutations'
import {BiSolidFileArchive, BiSync} from 'react-icons/bi'
import secureLocalStorage from 'react-secure-storage'
// import { APiBigDataCorp } from '../../../../../../../services/api/apiBigDataCorp'

type Props = {
  id: number
  idProprietario: number
  idTerreno: number
  cpf: string
  quill_status: string
  quill_file?: string
}

export const Buttons: React.FC<Props> = ({
  id,
  idProprietario,
  idTerreno,
  cpf,
  quill_status,
  quill_file,
}) => {
  const {HandleDeleteProprietarios, loading} = MutationDeleteProprietarios()
  const {FormDiligenciaHistorico} = MutationCreateDiligenciaHistorico()
  const [putProprietario] = useMutation(PUT_PROPRIETARIO)
  const [showQuillFile, setShowQuillFile] = useState(false)
  if (loading) {
    Swal.fire('Enviando Informações...', '')
    Swal.showLoading()
  }

  // const [idEditProprietario, setIdProprietario] = useState(null)
  const [showEdit, setShowEdit] = useState(false)

  function CloseModalEdit() {
    setShowEdit(false)
    // setIdProprietario(null)
  }

  function OpenModalEdit(id) {
    setShowEdit(true)
    // setIdProprietario(id)
  }

  function confirmDelete(id: number) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      showCloseButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await HandleDeleteProprietarios({
          variables: {deleteProprietarioId: idProprietario},
        })
        if (!result) {
          Swal.fire('ERRO!', 'Ocorreu um erro durante a execução.', 'warning')
        } else {
          Swal.fire('Sucesso!', 'Proprietario deletado com sucesso.', 'success')
        }
      }
    })
  }

  async function getDiligenceData(cpf: string, idProprietario: number) {
    await FormDiligenciaHistorico({
      id_empresa: Number(secureLocalStorage.getItem('id_empresa')) || undefined,
      id_proprietario: idProprietario,
      id_terreno: idTerreno || undefined,
      id_user: Number(secureLocalStorage.getItem('id_user')) || undefined,
    }).then((result) => {
      if (result.errors) {
        Swal.fire(
          'ERRO!',
          result.errors[0].message || 'Falha ao registrar a diligência.',
          'warning'
        )
        return
      } else {
        Swal.fire(
          'Sucesso!',
          'Diligencia solicitada com sucesso. O processamento ja foi iniciado e pode levar ate 15 minutos. Assim que for concluido, voce recebera um e-mail com a confirmacao.',
          'success'
        )
      }
    })
  }
  function diligences(cpf: string, idProprietario: number) {
    Swal.fire({
      title: 'Fazer diligência Jurídica ?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      showCloseButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Enviando Informações...',
          text: 'Por favor, aguarde.',
          icon: 'info',
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })
        getDiligenceData(cpf, idProprietario)
        // if (!result) {
        //   Swal.fire('ERRO!', 'Ocorreu um erro durante a execução.', 'warning')
        // } else {
        //   Swal.fire('Sucesso!', 'Proprietario deletado com sucesso.', 'success')
        // }
      } else {
        return
      }
    })
  }

  function openQuillDocument() {
    if (!quill_file) {
      Swal.fire('Aviso', 'Documento não disponível para este proprietário.', 'warning')
      return
    }
    setShowQuillFile(true)
  }

  return (
    <>
      <Modal
        centered
        size='xl'
        show={showQuillFile}
        onHide={() => setShowQuillFile(false)}
        dialogClassName='modal-95w'
      >
        <Modal.Header closeButton>
          <Modal.Title>Documento da diligência</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{height: '80vh'}}>
          {quill_file ? (
            <iframe
              title='Documento Quill'
              src={'https://urbit-quill.s3.sa-east-1.amazonaws.com/' + quill_file}
              width='100%'
              height='100%'
              style={{border: 'none'}}
            />
          ) : (
            <p>Documento indisponível.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          {quill_file ? (
            <a href={quill_file} target='_blank' rel='noreferrer' className='btn btn-light-primary'>
              Abrir em nova aba
            </a>
          ) : null}
          <button className='btn btn-secondary' onClick={() => setShowQuillFile(false)}>
            Fechar
          </button>
        </Modal.Footer>
      </Modal>

      <div className='justify-content-end d-flex align-items-center '>
        <button
          onClick={(e) => {
            OpenModalEdit(id)
          }}
          className='btn btn-icon btn-light-success btn-sm me-2'
        >
          <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
        </button>
        {showEdit ? (
          <EditFormImoveProprietarios
            idProprietario={idProprietario}
            closeModal={CloseModalEdit}
            show={showEdit}
          />
        ) : (
          <></>
        )}

        <button
          onClick={(e) => {
            confirmDelete(id)
          }}
          className='btn btn-icon btn-light-danger btn-sm me-2'
        >
          <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
        </button>

        {!quill_status ? (
          <button
            onClick={(e) => {
              diligences(cpf, idProprietario)
            }}
            className='btn btn- btn-light-secondary btn-sm me-2'
          >
            <BiSync className='svg-icon-3' />
            Fazer diligência
          </button>
        ) : (
          <>
            {quill_status === 'processando' ? (
              <span className='badge badge-info'>{quill_status}</span>
            ) : (
              ''
            )}
            {quill_status === 'concluido' ? (
              <button
                type='button'
                className='btn btn-success border-0'
                style={{cursor: 'pointer'}}
                onClick={openQuillDocument}
                title='Visualizar documento'
              >
                <BiSolidFileArchive></BiSolidFileArchive> Abrir Arquivo
              </button>
            ) : (
              ''
            )}
            {quill_status === 'error' ? (
              <span className='badge badge-danger'>Erro. Entre em contato</span>
            ) : (
              ''
            )}
          </>
        )}
      </div>
    </>
  )
}
